import React from 'react';
import { Link } from '../basic/Links';
import { BoundaryProps } from '../boundaries/Boundary';

export const TEST_ID = {
  MAIN: 'location-not-found'
};

export interface NotFoundProps extends BoundaryProps {
  basePath: string;
  label: string;
}

export const NotFound: React.FC<NotFoundProps> = props => {
  const { basePath, label } = props;

  return (
    <div style={{ textAlign: 'center' }} data-testid={TEST_ID.MAIN}>
      We couldn't find that location. We aren't sure how to continue, but you
      can <Link href={basePath}>go to {label}</Link>
    </div>
  );
};

NotFound.defaultProps = {
  default: true
};
